import { Box, Flex, Grid, Text, useDisclosure } from "@chakra-ui/react"
import RiskBox from "./RiskBox"
import { Files } from "@phosphor-icons/react"
import { useState } from "react";
import { PlusCircle } from "@phosphor-icons/react/dist/ssr";
import { riskColor } from "enums/labelRisks";
import LifeAssessment from "components/LifeAssessment";
import dateFormat from "functions/dateFormat";
import { Assessment } from "interfaces/assessment";

interface Props {
	assessment: Assessment
}


const TimelineEvent = ({ assessment }: Props) => {
	const metrics = assessment?.metrics || [];
	const evaluations = assessment?.evaluations || [];

	const [hover, setHover] = useState(false);
	const { isOpen, onOpen, onClose } = useDisclosure();

	return (
		<Box
			w="full"
			cursor="pointer"
			_hover={{ opacity: 0.75 }}
			onClick={() => assessment.answered_at !== null ? onOpen() : null}
			onMouseEnter={() => assessment.answered_at !== null ? setHover(true) : null}
			onMouseLeave={() => assessment.answered_at !== null ? setHover(false) : null}
		>
			<LifeAssessment isOpen={isOpen} onClose={onClose} title={assessment.event.name} evaluations={evaluations}/>
			<Flex>
				<Flex justifyContent="center" alignItems="center" mr="20px">
					{
						hover ?
							<PlusCircle size={36} />
							: <Files size={36} />
					}

				</Flex>
				<Box>
					<Box mb="12px">
						<Text fontSize="lg" fontWeight="bold">{assessment.event.name}</Text>
						{
							assessment.answered_at === null 
								? <Text fontSize="md">Não preenchido</Text>
								: <Text fontSize="md">{dateFormat(assessment.answered_at, "dd/MM/yyyy")}</Text>
								
						}
						
					</Box>
					<Text fontSize="md">Apuração dos Riscos</Text>
					<Grid
						templateColumns="repeat(3, 1fr)"
						gap="4"
					>
						{
							metrics.map(metric => <RiskBox risk={`${metric.name}: ${metric.result}`} color={riskColor[metric.result as keyof typeof riskColor]} />)
						}
					</Grid>
				</Box>
			</Flex>
		</Box>
	)
}

export default TimelineEvent
